import React from 'react';
import './About.css';
import img from '../../images/Abdullah-Al-Akash.jpg';
import Skill from './Skill';
import Education from './Education';
import linkedIn from '../../images/linkedIn.png';
import gitHub from '../../images/github.png';
import facebook from '../../images/facebook.png';

const About = () => {
        return (
                <div className="about-section mt-5 pt-5">
                        <div className="container">
                                <div className="row">
                                        <div className="col-lg-4 col-12 mx-auto"
                                                data-aos="zoom-in-up"
                                                data-aos-duration="3000"
                                        >
                                                <img className="img-fluid main-img" src={img} alt="Abdullah-Al-Akash" />
                                        </div>
                                </div>
                                <div className="row mt-4">
                                        <div className="col-lg-5 col-12 mx-auto text-center">
                                                <div
                                                        data-aos="flip-left"
                                                        data-aos-easing="ease-out-cubic"
                                                        data-aos-duration="2000"
                                                >
                                                        <h2 className="fw-bold text-white text-decoration-underline">I am <span className="brand-color">Abdullah Al Akash</span>,</h2>
                                                        <p className="text-white mt-3">I am a self-curious Web Developer as my educational background is not related programming, I am student of mathematics but enjoy Web Development so much, try to develop the front end of a web application using React.js and the back-end using Node.js(express) with comfortable. Besides always ready to learn any new technology.
                                                                <br /> <br />

                                                                Honestly, I am excited to start my career as a web developer as well as to enhance my workplace and reputation day by day.
                                                                <br /> <br /> I always focus on learning new technology. I am currently studying in the Discipline of Mathematics, Khulna University.</p>
                                                </div>
                                                <div
                                                        data-aos="fade-up"
                                                        data-aos-anchor-placement="top-bottom"
                                                >
                                                        <a href="https://www.linkedin.com/in/abdullahalakash/" target="_blank">
                                                                <img className="single-icon" src={linkedIn} alt="" />
                                                        </a>

                                                        <a href="https://github.com/Abdullah-Al-Akash" target="_blank">
                                                                <img className="single-icon" src={gitHub} alt="" />
                                                        </a>

                                                        <a href="https://web.facebook.com/abdullah.akash.al" target="_blank">
                                                                <img className="single-icon" src={facebook} alt="" />
                                                        </a>
                                                </div>
                                        </div>
                                </div>
                                <div className="row mt-5">
                                        <div className="col-lg-6">
                                                <Skill />
                                        </div>
                                        <div className="col-lg-6">
                                                <Education />
                                        </div>
                                </div>
                        </div>
                </div>
        );
};

export default About;